﻿import { FIQAssist } from "../app";
import { Component, Input, Output, Inject, Attribute } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'dropdownlist',
    template: `<div class="dropdownlist ng-class:{readonly:$ctrl.readOnly}" id="{{'dropdownlist_'+$id}}" click-outside="$ctrl.close()">
                    <table class="selector {{$ctrl.opened ? 'selectopen':'selectclose'}}"  ng-click="$ctrl.open($event)"><tr>

                <td class="listTitle" >{{$ctrl.label}}</td>
                <td class="icon"><span  class="{{$ctrl.opened ? 'icon-dropUP':'icon-dropdown'}}">
                    <span class="path1"></span><span class="path2"></span></span></td>
                </tr></table>
                <div class="droplist" ng-if="$ctrl.opened">
                    <div class="droplistitem" ng-repeat="item in $ctrl._items" ng-click="$ctrl.itemclick($event, item.key)">
                        <span ng-keypress="%ctrl.onkey($event,item.key)" class="label" tooltip-class="customTooltipTB" tooltip-append-to-body="true" tooltip-placement="bottom-right" uib-tooltip="{{item.text}}">{{item.text}}</span>
                    </div>
               </div>`
})
export class DropdownList {
    constructor(
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService) {
    }

    @Input() public readOnly:boolean;

    private isInitialized: boolean = false;
    private _items: Dropdownlistitem[];

    public $onInit() {
        this.isInitialized = true;
    }

    @Input() public get items(): Dropdownlistitem[] {
        return this._items;
    }
    public set items(value: Dropdownlistitem[]) {
        this._items = value;
    }

    private _title: string;

    @Input() public get label(): string {
        return this._title;
    }
    public set label(value: string) {
        this._title = value;
    }

    @Output() public onitemclicked: (args: { selected: any }) => void;

    public opened: boolean = false;

    public open(event) {
        if(!this.readOnly)
            this.opened = !this.opened;
    }

    public close() {
        if (this.opened) {
            this.opened = false;
        }
    }

    public itemclick(event: JQueryEventObject, key: any) {
        event.preventDefault();
        this.opened = false;
        this.onitemclicked({ selected: key});
    }

    public imagePicture(checked: boolean): string {
        return checked ? "css/images/checkliston.png" : "css/images/checklistoff.png";
    }
}

export class Dropdownlistitem {
    public key: any;
    public text: string;
    public icon: string;
    public selected?: boolean;
}
